import script from "./SearchPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchPage.vue?vue&type=script&setup=true&lang=js"

import "./SearchPage.vue?vue&type=style&index=0&id=321bdb09&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-321bdb09"]])

export default __exports__